import createStore from '../create-store';
import reducers from './reducers';
import {initialState} from './data';

export const createSessionStore = data => (
  createStore(reducers, {...initialState, ...data})
);

export default createStore(reducers, initialState);
